import { FC, SVGProps } from 'react'

import amazon from 'Icons/shop/cards/amazon.svg'
import amex from 'Icons/shop/cards/amex.svg'
import aura from 'Icons/shop/cards/aura.svg'
import bb from 'Icons/shop/cards/bb.svg'
import boleto from 'Icons/shop/cards/boleto.svg'
import bradesco from 'Icons/shop/cards/bradesco.svg'
import caixa from 'Icons/shop/cards/caixa.svg'
import cielo from 'Icons/shop/cards/cielo.svg'
import cirrus from 'Icons/shop/cards/cirrus.svg'
import diners from 'Icons/shop/cards/diners.svg'
import direct_debit from 'Icons/shop/cards/direct_debit.svg'
import discover from 'Icons/shop/cards/discover.svg'
import ebay from 'Icons/shop/cards/ebay.svg'
import elavon from 'Icons/shop/cards/elavon.svg'
import elo from 'Icons/shop/cards/elo.svg'
import eway from 'Icons/shop/cards/eway.svg'
import generic from 'Icons/shop/cards/generic.svg'
import global from 'Icons/shop/cards/global.svg'
import hsbc from 'Icons/shop/cards/hsbc.svg'
import itau from 'Icons/shop/cards/itau.svg'
import jcb from 'Icons/shop/cards/jcb.svg'
import maestro from 'Icons/shop/cards/maestro.svg'
import mastercard from 'Icons/shop/cards/mastercard.svg'
import pagseguro from 'Icons/shop/cards/pagseguro.svg'
import paypal from 'Icons/shop/cards/paypal.svg'
import rede from 'Icons/shop/cards/rede.svg'
import sage from 'Icons/shop/cards/sage.svg'
import santander from 'Icons/shop/cards/santander.svg'
import shopify from 'Icons/shop/cards/shopify.svg'
import skrill from 'Icons/shop/cards/skrill.svg'
import skrill_moneybookers from 'Icons/shop/cards/skrill_moneybookers.svg'
import solo from 'Icons/shop/cards/solo.svg'
import stone from 'Icons/shop/cards/stone.svg'
import visa from 'Icons/shop/cards/visa.svg'
import visa_electron from 'Icons/shop/cards/visa_electron.svg'
import wallet from 'Icons/shop/cards/wallet.svg'
import western from 'Icons/shop/cards/western.svg'
import worldpay from 'Icons/shop/cards/worldpay.svg'

export default {
  amazon,
  american_express: amex,
  amex,
  aura,
  bb,
  boleto,
  bradesco,
  caixa,
  cielo,
  cirrus,
  diners,
  direct_debit,
  discover,
  ebay,
  elavon,
  elo,
  eway,
  generic,
  global,
  hsbc,
  itau,
  jcb,
  maestro,
  mastercard,
  master: mastercard,
  pagseguro,
  paypal,
  rede,
  sage,
  santander,
  shopify,
  skrill_moneybookers,
  skrill,
  solo,
  stone,
  visa_electron,
  visa,
  wallet,
  western,
  worldpay,
} as { [key: string]: FC<SVGProps<SVGSVGElement>> }
